var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('h2',[_vm._v(" 您访问的页面不存在！ ")]),_c('h2',{staticClass:"focus"},[_vm._v(" 页面路径："+_vm._s(_vm.$route.fullPath)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }